import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { HouseholdProvider } from "@/contexts/HouseholdContext";
import { I18nProvider } from "@/contexts/I18nContext";

/**
 * Exclusive onboarding gate per [[specs/new-user-onboarding-and-join-flow]].
 * Sits outside the AppLayout so chrome doesn't render — matches iOS
 * `OnboardingGateView`. Mounts Auth + Household + I18n providers so the page
 * can read session, react to membership changes, and render translated copy.
 */
export function OnboardingLayout() {
  return (
    <AuthProvider>
      <HouseholdProvider>
        <I18nProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
            <Outlet />
          </div>
        </I18nProvider>
      </HouseholdProvider>
    </AuthProvider>
  );
}
